import { Button, Card, Stack } from "@mui/material";
import CustomBreadcrumbs from "../../../components/custom-breadcrumbs/custom-breadcrumbs";
import PageComponent from "../../../components/page";
import Iconify from "../../../components/iconify";
import useBranchList from "./useList";
import BranchFiltersComponent from "../components/filters";
import SortByComponent from "../../../components/sort-by-component";
import { branchOrderOptions, columnsTable } from "../../../constants/branch";
import TableComponent from "../../../components/table";
import { IBranch } from "../../../types/branch";
import BranchTableRowComponent from "../components/table-row";
import BranchDialogComponent from "../components/branch-dialog";
import useBranchUpdate from "./useUpdate";
import BranchDialogUpdateComponent from "../components/branch-dialog-update";

const BranchesListPage = () => {

    const { canReset, filters, handleFilters, handleResetFilters, openFilters, table, loading, branchesList, getBranches, openNewBranch, methods, onSubmit, isSubmitting, activeBranch, deleteBranch } = useBranchList();
    const { loadingUpdate, onSubmitUpdate, openUpdateBranch, updateMethods, selectBranchToUpdate, closeDialogUpdate } = useBranchUpdate(loading, getBranches);

    return (
        <PageComponent>
            <>
                <CustomBreadcrumbs
                    heading="Filiais"
                    links={[
                        {
                            name: 'Filiais'
                        },
                        {
                            name: 'Lista'
                        }
                    ]}
                    action={
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon={'mingcute:add-line'} />}
                            onClick={openNewBranch.onTrue}
                        >
                            Nova Filial
                        </Button>
                    }
                    sx={{ mb: { xs: 3, md: 5 } }}
                />
                <Stack
                    spacing={3}
                    justifyContent={{ xs: 'space-between', md: 'flex-end' }}
                    alignItems={'center'}
                    direction={'row'}
                    sx={{ mb: { xs: 3, md: 5 } }}
                >
                    <BranchFiltersComponent
                        canReset={canReset}
                        onClose={openFilters.onFalse}
                        onOpen={openFilters.onTrue}
                        open={openFilters.value}
                        resetFilters={handleResetFilters}
                        filters={filters}
                        handleFilters={handleFilters}
                        getResults={getBranches}
                    />
                    <SortByComponent
                        direction={table.direction}
                        onSort={table.onSort}
                        sortBy={table.sortBy}
                        sortOptions={branchOrderOptions}
                    />
                </Stack>

                <Card>
                    <TableComponent
                        headLabel={columnsTable}
                        loading={loading.value}
                        table={table}
                        totalCount={branchesList?.totalCount ?? 0}
                    >
                        <>
                            {
                                branchesList?.data?.map((branch: IBranch) => (
                                    <BranchTableRowComponent
                                        key={branch.id}
                                        row={branch}
                                        onDeleteRow={(id: number) => branch.deletedAt ? activeBranch(id) : deleteBranch(id)}
                                        onEditRow={() => selectBranchToUpdate(branch)}
                                    />
                                ))
                            }
                        </>
                    </TableComponent>
                </Card>

                <BranchDialogComponent
                    open={openNewBranch.value}
                    onClose={openNewBranch.onFalse}
                    methods={methods}
                    onSubmit={onSubmit}
                    isSubmitting={isSubmitting}
                />

                <BranchDialogUpdateComponent
                    open={openUpdateBranch.value}
                    closeDialogUpdate={closeDialogUpdate}
                    methods={updateMethods}
                    onSubmit={onSubmitUpdate}
                    isSubmitting={loadingUpdate.value}
                />
            </>
        </PageComponent>
    );

}

export default BranchesListPage;